import React, { FC } from 'react';
import { Alert } from 'reactstrap';
import { PublicHotelReleaseGroup } from '../../../shared/hotel';
import { MaterialIconText } from '../../components/MaterialIconText';
import { useTranslation } from '../../translations';

interface Props {
  readonly wave: PublicHotelReleaseGroup;
}

export const WaveEligibility: FC<Props> = ({ wave }) => {
  const { eligibility } = wave;
  const { ts } = useTranslation();

  return (
    <>
      {eligibility.isEligible ? (
        <Alert color="success" fade={false} id="hotel_eligible">
          <MaterialIconText name="check">
            {ts('you_are_eligible_to_enter_this_wave')}
          </MaterialIconText>
        </Alert>
      ) : (
        <Alert color="danger" fade={false} id="hotel_not_eligible">
          <MaterialIconText name="warning">
            {ts('you_are_not_eligible_to_enter_this_wave')}
          </MaterialIconText>
        </Alert>
      )}
      {/* TODO: Allow configuration to display wave entrance information and criteria */}
      {/* <p>
        <small>You must meet the following criteria to be eligible to enter this wave:</small>
      </p>
      <ul className="wave-eligibility-list">
        <CriteriaMap wave={wave} />
      </ul> */}
    </>
  );
};

/*
 * const CriteriaMap: FC<Props> = ({ wave }): React.JSX.Element => {
 *   const { requiredRoles, requiredProducts } = wave;
 *   const eligibility = wave.eligibility!;
 */

/*
 *   const criteriaList: React.JSX.Element[] = [];
 *   const orGroups = new Map<string, JSX.Element[]>();
 */

/*
 *   for (const criteria of eligibility.criteria) {
 *     let helpText = criteriaHelpTextMap[criteria.condition];
 */

/*
 *     const element = (
 *       <li
 *         className={classNames(
 *           {
 *             passed: criteria.met,
 *             failed: !criteria.met && !orMet,
 *             'or-passed': !criteria.met && orMet,
 *           },
 *           'wave-eligibility',
 *         )}
 *         key={criteria.condition}
 *       >
 *         <div className="wave-eligibility-criteria">
 *           <MaterialIconText
 *             name={criteria.met ? 'check' : orMet ? 'remove_circle_outline' : 'clear'}
 *           >
 *             {criteria.condition}
 *           </MaterialIconText>
 *         </div>
 *         {!criteria.met && (
 *           <div className={classNames({ 'or-passed': orMet }, 'wave-eligibility-helptext')}>
 *             &mdash; {helpText}
 *           </div>
 *         )}
 *       </li>
 *     );
 */

/*
 *     if (criteria.or) {
 *       const orKey = [...criteria.or, criteria.condition].sort().join('-');
 *       const orGroup = orGroups.get(orKey) ?? [];
 *       orGroup.push(element);
 *       orGroups.set(orKey, orGroup);
 *     } else {
 *       criteriaList.push(element);
 *     }
 *   }
 */

/*
 *   for (const [orKey, orConditions] of orGroups) {
 *     criteriaList.push(
 *       <li className="wave-eligibility or-group" key={orKey}>
 *         {orConditions.map((condition, idx) => (
 *           <>
 *             {condition}
 *             {idx < orConditions.length - 1 && <div className="wave-eligibility-or">OR</div>}
 *           </>
 *         ))}
 *       </li>,
 *     );
 *   }
 */

/*
 *   return <>{criteriaList}</>;
 * };
 */
